export const deletePolicyMenuGroupHeaderText = "HSd";
export default {deletePolicyMenuGroupHeaderText};